import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, CheckCircle, FileText, AlertCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';

const CQCStatus = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#E8F4FC] to-[#F0EDF7] py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <Shield className="w-16 h-16 text-[#4A90E2] mx-auto" />
            <h1 className="heading-hero">CQC Status & Regulation</h1>
            <p className="body-large">
              Committed to meeting all regulatory requirements applicable to the services we provide.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="section bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <p className="body-large text-center mb-12">
              Three Spheres Healthcare is committed to meeting all regulatory requirements applicable to the services we provide.
            </p>

            <Card className="p-8 md:p-12 border-0 mb-12">
              <div className="flex items-start gap-6">
                <FileText className="text-[#4A90E2] flex-shrink-0 mt-1" size={32} />
                <div>
                  <h3 className="heading-3 mb-4">Our Regulatory Status</h3>
                  <p className="body-medium text-gray-700 mb-4">
                    Some services provided by Three Spheres Healthcare require registration with the Care Quality Commission (CQC). Where registration is required, services are delivered in line with CQC regulations and fundamental standards.
                  </p>
                  <div className="bg-[#E8F4FC] rounded-lg p-6 mt-6">
                    <div className="flex items-start gap-4">
                      <AlertCircle className="text-[#4A90E2] flex-shrink-0 mt-1" size={24} />
                      <div>
                        <h4 className="font-semibold text-lg mb-2 text-gray-900">Current Status</h4>
                        <p className="text-gray-700">
                          Our organisation is currently preparing for / in the process of CQC registration.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>

            {/* CQC Fundamental Standards */}
            <h2 className="heading-2 mb-8 text-center">CQC Fundamental Standards</h2>
            <p className="body-medium text-gray-700 text-center mb-8">
              We are committed to meeting the CQC's fundamental standards of quality and safety:
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-12">
              {[
                'Person-centred care',
                'Dignity and respect',
                'Consent',
                'Safety',
                'Safeguarding from abuse',
                'Food and drink',
                'Premises and equipment',
                'Complaints',
                'Good governance',
                'Staffing',
                'Fit and proper persons',
                'Duty of candour',
                'Display of ratings',
                'Notification of changes'
              ].map((standard, index) => (
                <Card key={index} className="p-4 border-0 bg-[#E8F4FC]">
                  <div className="flex items-center gap-3">
                    <CheckCircle className="text-[#4A90E2] flex-shrink-0" size={20} />
                    <span className="text-gray-800">{standard}</span>
                  </div>
                </Card>
              ))}
            </div>

            {/* Partnership */}
            <div className="bg-gradient-to-br from-[#E8F4FC] to-[#F0EDF7] rounded-2xl p-8 md:p-12 text-center">
              <Shield className="w-12 h-12 text-[#4A90E2] mx-auto mb-6" />
              <p className="body-large text-gray-800">
                We work in partnership with commissioners, local authorities, and healthcare professionals to ensure services are safe, transparent, and accountable.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section bg-gradient-to-r from-[#4A90E2] to-[#7B68BE] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <h2 className="heading-2 text-white">Questions About Our Regulatory Status?</h2>
            <p className="body-large text-white/90">
              Contact us for more information about our CQC registration and regulatory compliance.
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-white text-[#4A90E2] hover:bg-gray-100">
                Get in Touch
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CQCStatus;
